import { MAGIC_NUMBERS_MAPPING, MIME_TYPE_MAPPING } from "../constants/fileHandler";

//this will return Mime Type mapping for supported file types
export const getSupportedMimeTypes = (supportedFileTypes = []) => {
	return supportedFileTypes.map(file => MIME_TYPE_MAPPING[file]).flat()
}

export const validateFiles = async (file:any, supportedFileTypes = [], fileSizeLimit = 100) => {
    let fileRegex = new RegExp('\.(' + supportedFileTypes.join("|") + ')$', 'i')
    
    let validationObj = {
      valid: true,
      invalidReason: ''
    }
    const lastDot = file.name.lastIndexOf('.');
    const ext = file.name.substring(lastDot + 1);

    //validating the extension of file
    if(!fileRegex.test(file.name)) {
        validationObj['valid'] = false
        validationObj['invalidReason'] = `Invalid file type`
      }

    //validating the size of file
    let fileSizeInMB = (file.size/1048576)
    if(validationObj['valid'] && fileSizeInMB > fileSizeLimit){
      validationObj['invalidReason'] = `Please select an image or .pdf file with less than 10 MB`
      validationObj['valid'] = false
    }
    //validating file name length
    if(validationObj['valid'] && file.name.length > 70){
      validationObj['invalidReason'] = "File name can't Be more than 70 characters"
      validationObj['valid'] = false
    }

    let mimeTypes:any = getSupportedMimeTypes(supportedFileTypes)
    //validating mime type of file
    if (validationObj['valid'] && !mimeTypes.includes(file.type)) {
      validationObj['valid'] = false
      validationObj['invalidReason'] = 'File Validation Failed.'
    }
  
    let validMagicNumbers = MAGIC_NUMBERS_MAPPING[ext]
    console.log("Valide",validMagicNumbers,ext,mimeTypes,file)

    if (!validMagicNumbers || !validationObj['valid']) {
      validationObj['valid'] = false
      validationObj['invalidReason'] = 'File Validation Failed.'
      return validationObj
    }

    let result = await new Promise((resolve) => {
        let fileReader = new FileReader();
        fileReader.onload = (e:any) => {
          const arrayBuffer = e.target.result;
          console.log("aray buffer",arrayBuffer)
          let isValid = false;
          for (let magicNumber of validMagicNumbers) {
            // Read the first n bytes of the file
            let bytesToRead = magicNumber.length / 2;
            const uint8Array = new Uint8Array(arrayBuffer.slice(0, bytesToRead)); // Read the first n bytes
      
            // Convert the bytes to a hexadecimal string
            const hexString = Array.from(uint8Array)
              .map((byte) => {
                let hexByte = byte.toString(16)
                return hexByte.length == 2 ? hexByte : '0' + hexByte
              })
              .join('');
            //validating the Magic number of allowed extension
            console.log("sss",magicNumber, hexString.toUpperCase())
            if(magicNumber == hexString.toUpperCase()) {
              validationObj['valid'] = true
              validationObj['invalidReason'] = ''
              resolve(validationObj)
              return
            }else{
              validationObj['valid'] = false
              validationObj['invalidReason'] = 'File Validation Failed.'
            }
          }
          resolve(validationObj)
        }
        fileReader.readAsArrayBuffer(file);
        return result;
    });
    return result
}

export const generateFileHash = async (file) => {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};
